import { Camera, UploadSimple, FilePdf, Images, EnvelopeSimple } from "@phosphor-icons/react";

// Maps a receipt's stored `source` to a label, icon and colour.
export const SOURCE_META = {
  scan: { label: "Scanned", Icon: Camera, color: "#6E3FFC" },
  upload: { label: "Uploaded", Icon: UploadSimple, color: "#2BB0C4" },
  pdf: { label: "PDF", Icon: FilePdf, color: "#E4572E" },
  multi: { label: "Uploaded", Icon: Images, color: "#2BB0C4" },
  email: { label: "Emailed", Icon: EnvelopeSimple, color: "#C79A00" },
};

export function sourceMeta(source) {
  return SOURCE_META[source] || SOURCE_META.upload;
}

// Small pill showing how a receipt was captured. `iconOnly` renders a compact chip.
export function SourceBadge({ source, className = "", iconOnly = false }) {
  const { label, Icon, color } = sourceMeta(source);
  return (
    <span
      data-testid={`source-badge-${source || "upload"}`}
      title={label}
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold ${className}`}
      style={{ background: `${color}1a`, color }}
    >
      <Icon size={12} weight="bold" />
      {!iconOnly && label}
    </span>
  );
}
